export default {
  name: 'appointmentHours',
  props: {
    availableHours: Array,
    selectedHour: String
  },
  methods: {
    handleClickHour (hour) {
      this.$emit('clickHour', hour)
    }
  }
}
